var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFeatures4K(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 18,
    viewBox: "0 0 31 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.237375 14.592V11.952L8.08538 0.719999H11.9974V11.664H14.1094V14.592H11.9974V18H8.63738V14.592H0.237375ZM8.85338 4.32L3.93338 11.664H8.85338V4.32ZM26.0886 18L19.9926 10.536V18H16.6326V1.248H19.9926V8.76L26.0886 1.248H30.1446L23.2326 9.552L30.3366 18H26.0886Z",
    fill: "#067FE5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatures4K);
export default __webpack_public_path__ + "static/media/icon-features-4k.abc8c841268d4fe43951646dfbfe2005.svg";
export { ForwardRef as ReactComponent };